import React from 'react';
import { TableHead as MuiTableHead, type TableHeadProps } from '@mui/material';

export type DataHeadProps = TableHeadProps;

export default function DataHead({ children, ...props }: DataHeadProps) {
  return <MuiTableHead {...props}>{children}</MuiTableHead>;
}
